import * as React from 'react';

import { cn } from '../lib/utils';

export type TextareaElement = React.ComponentRef<'textarea'>;
export type TextareaProps = React.ComponentProps<'textarea'>;
function Textarea({ className, ...props }: TextareaProps): React.JSX.Element {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 text-sm',
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
